<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Material Detail Transport
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.unsize"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="crop_din"
              hint="part size"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.pkgsize"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="straighten"
              hint="package size"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.unwht"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="adjust"
              hint="part weight"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.pkgwht"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="scale"
              hint="package weight"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
                :change="updateFormChar()"
                v-model="localForm.unit"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="tag"
                hint="units per part"
                persistent-hint
                ></v-text-field>
              </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.unpkg"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="blur_linear"
              hint="parts / pkg"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.load"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="login"
              hint="loading requirements"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.care"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="high_quality"
              hint="special care during transport"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.unload"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="logout"
              hint="unloading requirements"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Transport Hazards and Instructions
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.trans"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="material transport addditional comments"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        pkgsize: "",
        unsize: "",
        pkgwht: "",
        unwht: "",
        unpkg: "",
        unit: "",
        unload: "",
        load: "",
        care: "",
        trans: ""
      },
      orgForm: {
        pkgsize: "",
        unsize: "",
        pkgwht: "",
        unwht: "",
        unpkg: "",
        unit: "",
        unload: "",
        load: "",
        care: "",
        trans: ""
      }
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.pkgsize = this.getDetail.char.pkgsize;
    this.localForm.unsize = this.getDetail.char.unsize;
    this.localForm.unpkg = this.getDetail.char.unpkg;
    this.localForm.unit = this.getDetail.char.unit;
    this.localForm.pkgwht = this.getDetail.char.pkgwht;
    this.localForm.unwht = this.getDetail.char.unwht;
    this.localForm.load = this.getDetail.char.load;
    this.localForm.unload = this.getDetail.char.unload;
    this.localForm.care = this.getDetail.char.care;
    this.localForm.trans = this.getDetail.char.trans;

    this.orgForm.pkgsize = this.getDetail.char.pkgsize;
    this.orgForm.unsize = this.getDetail.char.unsize;
    this.orgForm.unpkg = this.getDetail.char.unpkg;
    this.orgForm.unit = this.getDetail.char.unit;
    this.orgForm.pkgwht = this.getDetail.char.pkgwht;
    this.orgForm.unwht = this.getDetail.char.unwht;
    this.orgForm.unload = this.getDetail.char.unload;
    this.orgForm.load = this.getDetail.char.load;
    this.orgForm.care = this.getDetail.char.care;
    this.orgForm.trans = this.getDetail.char.trans;
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme
    // charOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.unsize !== this.orgForm.unsize &&
        this.localForm.unsize !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unsize = this.localForm.unsize;
        // basic
        char.unsize = this.localForm.unsize;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.pkgsize !== this.orgForm.pkgsize &&
        this.localForm.pkgsize !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.pkgsize = this.localForm.pkgsize;
        // basic
        char.pkgsize = this.localForm.pkgsize;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.unload !== this.orgForm.unload &&
        this.localForm.unload !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unload = this.localForm.unload;
        // basic
        char.unload = this.localForm.unload;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.load !== this.orgForm.load &&
        this.localForm.load !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.load = this.localForm.load;
        // basic
        char.load = this.localForm.load;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.care !== this.orgForm.care &&
        this.localForm.care !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.care = this.localForm.care;
        // basic
        char.care = this.localForm.care;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.unpkg !== this.orgForm.unpkg &&
        this.localForm.unpkg !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unpkg = this.localForm.unpkg;
        // basic
        char.unpkg = this.localForm.unpkg;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.unit !== this.orgForm.unit &&
        this.localForm.unit !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unit = this.localForm.unit;
        // basic
        char.unit = this.localForm.unit;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.pkgwht !== this.orgForm.pkgwht &&
        this.localForm.pkgwht !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.pkgwht = this.localForm.pkgwht;
        // basic
        char.pkgwht = this.localForm.pkgwht;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.unwht !== this.orgForm.unwht &&
        this.localForm.unwht !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unwht = this.localForm.unwht;
        // basic
        char.unwht = this.localForm.unwht;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.unload !== this.orgForm.unload &&
        this.localForm.unload !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.unload = this.localForm.unload;
        // basic
        char.unload = this.localForm.unload;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 10); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.trans !== this.orgForm.trans &&
        this.localForm.trans !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.trans = this.localForm.trans;
        // basic
        char.trans = this.localForm.trans;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 11); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
